module.exports = __webpack_public_path__ + "img/bankkok.a9080c5c.png";